import { Component } from 'react';

import './filter.css';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  update(e) {
    const { update_filter } = this.props;
    const newValue = e.target.value;
    this.setState({ value: newValue });
    update_filter(newValue);
  }

  render() {
    const { value } = this.state;

    return (
      <div className="personnel_filter">
        <label className="personnel_filter_label">Filter:</label>
        <input className="personnel_filter_input" type="text" value={value} onChange={this.update.bind(this)}></input>
      </div>
    );
  }
}

export default Filter;
